// Registry for provider-specific custom-scheme return URLs (e.g. Epassi's wallet
// deep-link return) that need to be intercepted before AppUrlListener's generic
// appUrlOpen handling runs. Lets each provider module own its own recognition
// logic instead of AppUrlListener growing a hardcoded if-branch per provider.

export type AppUrlHandler = (url: string) => boolean;

const handlers: AppUrlHandler[] = [];

// A handler returns true to claim the URL and stop further dispatch.
export function registerAppUrlHandler(handler: AppUrlHandler): void {
  handlers.push(handler);
}

export function dispatchAppUrlHandlers(url: string): boolean {
  return handlers.some((handler) => handler(url));
}
